import { SpreadingJob, SpreadingJobForm } from '@/models'
import type { TSpreadingJobsState } from '@/types/state-types/TSpreadingJobsState'

export default <TSpreadingJobsState>{
  jobForm: new SpreadingJobForm(),
  isSpreadingFormLoading: false,
  selectedFieldsToAssign: [],
  spreadingJobDetails: new SpreadingJob(),
  isSpreadingFormButtonLoading: false
}
